/**
 * @packageDocumentation
 * @module f1/number
 */

export interface Sign {
  /**
   * Returns the sign of a number.
   *
   * - `1` if `n` is positive
   * - `-1` if `n` is negative
   * - `0` if `n` is `0`
   * - Otherwise returns `NaN`
   *
   * @public
   * @function f1.sign
   * @param a the first number
   * @param b the second number
   * @example
   *
   * ```ts
   * f1.sign(2) => 1
   * f1.sign(-3) => -1
   *
   * f1.sign(-Infinity) => -1
   * f1.sign(Infinity) => 1
   *
   * f1.sign(0) => 1
   * f1.sign(-0) => 0
   *
   * f1.sign('-3') => NaN
   * ```
   */
  (val: number): number;
}

/**
 * @see Sign
 */
export default (val: number) => {
  return val === 0 ? 0 : val > 0 ? 1 : val < 0 ? -1 : NaN;
};
